import { useState } from "react";

import MemberGroupsFileData from "./MemberGroupsFileData";

const useMemberGroupsFileData = () => {
  const [memberGroupsFileUploadState, setMemberGroupsFileUploadState] = useState(MemberGroupsFileData.MEMBER_GROUPS_FILE_UPLOAD_INITIAL_STATE);
  const [memberGroupsFileDownloadState, setMemberGroupsFileDownloadState] = useState(MemberGroupsFileData.MEMBER_GROUPS_FILE_DOWNLOAD_INITIAL_STATE);

  const postGroupMemberGPAFile = (file) => {
    return MemberGroupsFileData.postGroupMemberGPAFileData(file, memberGroupsFileUploadState, setMemberGroupsFileUploadState);
  };

  const getGroupMemberGPAFile = (fileUrl) => {
    return MemberGroupsFileData.getGroupMemberGPAFileData(fileUrl, memberGroupsFileDownloadState, setMemberGroupsFileDownloadState);
  };

  const getFileNameFromUrl = (url) => {
    try {
      const fileNameWithDateTime = url.replace(MemberGroupsFileData.BASE_UPLOAD_URL, '');
      const indexOfEndOfDateTime = fileNameWithDateTime.indexOf('.') + 1;
      const fileName = fileNameWithDateTime.substring(indexOfEndOfDateTime);

      return decodeURI(fileName) || '';
    } catch (e) {
      return url;
    }
  };

  return {
    memberGroupsFileUploadState,
    memberGroupsFileDownloadState,
    postGroupMemberGPAFile,
    getGroupMemberGPAFile,
    getFileNameFromUrl
  };
};

export default useMemberGroupsFileData;